import React from 'react';
import RFPScheduleContent from './RFPScheduleContact';

export default function RFPSchedule(): JSX.Element {
  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <RFPScheduleContent />
    </div>
  );
}
